import Vue from 'vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import * as auth from '@/services/auth'
import permissions from 'comunet-btg-utah-repository-shared/permissions';
import moment from "moment";
import constants from "comunet-btg-utah-repository-shared/constants";
import validationRules from "@/helpers/validationrules";

Vue.config.productionTip = false;

Vue.prototype.$auth = auth;
Vue.prototype.$permissions = permissions;
Vue.prototype.$moment = moment;
Vue.prototype.$constants = constants;
Vue.prototype.$rules = validationRules.rules;

Vue.use(require('vue-moment'));
Vue.config.devtools = true;

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
    mounted() {
        // This check is here to handle tracking whether we have already added the key code
        if (!window.registeredKeyDown) {
            window.addEventListener('keydown', (event) => {
                store.dispatch("scanStore/keyDown", event);
            });

            window.registeredKeyDown = true;
        }
    }
}).$mount('#app')
